import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FunctionComponent } from 'react';

export const OFFLINE_USER_MESSAGE =
    'Your current status is offline, please contact our team for further information';

const useStyles = makeStyles((theme) => {
    return {
        root: {
            display: 'flex',
            backgroundColor: theme.palette.background.default,
            flexDirection: 'column',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            flexGrow: 1
        },
        image: {
            width: '300px',
            marginBottom: '20px'
        },
        text: {
            color: 'white',
            textAlign: 'center',
            alignItems: 'center',
            maxWidth: '600px'
        }
    };
});

type Props = Record<string, never>;

const OfflineView: FunctionComponent<Props> = ({}: Props) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <img className={classes.image} alt="Sad bee" src="bee.png" />
            <Typography variant="h5" component="h5" className={classes.text}>
                {OFFLINE_USER_MESSAGE}
            </Typography>
        </div>
    );
};

export default OfflineView;
